<!--@format-->
<template>
    <div :class="['company-field-hider-widget']">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Hide/Show Company Fields</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div>
                    <div class="bordered-container">
                        <div class="title">These changes will apply to all company pages</div>
                        <h1></h1>
                    </div>
                </div>

                <app-border-section topText="Company Information">
                    <div class="input-container">
                        <app-switch v-model="shownConfig.website">
                            <template>
                                <p6-website-svg
                                    class="svg"
                                    :style="{ opacity: shownConfig.website ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.website ? 'selected' : 'unselected'"
                                >
                                    Website
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.email">
                            <template>
                                <k5-email-outline-svg
                                    class="svg"
                                    color="#382153"
                                    :style="{ opacity: shownConfig.email ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.email ? 'selected' : 'unselected'"
                                >
                                    Email
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.assignedUsers">
                            <template>
                                <div
                                    class="button-label-no-svg"
                                    :class="shownConfig.assignedUsers ? 'selected' : 'unselected'"
                                >
                                    Assigned Users
                                </div>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.billingAddress">
                            <template>
                                <n24-location-outline
                                    class="svg"
                                    :style="{ opacity: shownConfig.billingAddress ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.billingAddress ? 'selected' : 'unselected'"
                                >
                                    Billing Address
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.phone">
                            <template>
                                <g5-call-outline-svg
                                    color="#382153"
                                    class="svg"
                                    :style="{ opacity: shownConfig.phone ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.phone ? 'selected' : 'unselected'"
                                >
                                    Phone
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.supportPhone">
                            <template>
                                <f18-mobile-outline-svg
                                    class="svg"
                                    :style="{ opacity: shownConfig.supportPhone ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.supportPhone ? 'selected' : 'unselected'"
                                >
                                    Support Phone
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.salesPhone">
                            <template>
                                <a26-headset-svg
                                    class="svg"
                                    :style="{ opacity: shownConfig.salesPhone ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.salesPhone ? 'selected' : 'unselected'"
                                >
                                    Sales Phone
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.accountingPhone">
                            <template>
                                <b26-calculator-coin-svg
                                    class="svg"
                                    :style="{ opacity: shownConfig.accountingPhone ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.accountingPhone ? 'selected' : 'unselected'"
                                >
                                    Accounting Phone
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.fax">
                            <template>
                                <c26-fax-machine-svg
                                    class="svg"
                                    :style="{ opacity: shownConfig.fax ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.fax ? 'selected' : 'unselected'"
                                >
                                    Fax
                                </span>
                            </template>
                        </app-switch>
                    </div>
                </app-border-section>
                <app-border-section topText="About this Company">
                    <div class="input-container">
                        <app-switch v-model="shownConfig.employees">
                            <template>
                                <div
                                    class="button-label-no-svg"
                                    :class="shownConfig.employees ? 'selected' : 'unselected'"
                                >
                                    Employees
                                </div>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.numberOfDevices">
                            <template>
                                <div
                                    class="button-label-no-svg"
                                    :class="shownConfig.numberOfDevices ? 'selected' : 'unselected'"
                                >
                                    Number of Devices
                                </div>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.vertical">
                            <template>
                                <div
                                    class="button-label-no-svg"
                                    :class="shownConfig.vertical ? 'selected' : 'unselected'"
                                >
                                    Vertical
                                </div>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.description">
                            <template>
                                <div
                                    class="button-label-no-svg"
                                    :class="shownConfig.description ? 'selected' : 'unselected'"
                                >
                                    Description
                                </div>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.services">
                            <template>
                                <div
                                    class="button-label-no-svg"
                                    :class="shownConfig.services ? 'selected' : 'unselected'"
                                >
                                    Services
                                </div>
                            </template>
                        </app-switch>
                    </div>
                </app-border-section>
                <app-border-section topText="Social Media">
                    <div class="input-container">
                        <app-switch v-model="shownConfig.facebook">
                            <template>
                                <p23-facebook-svg
                                    class="svg"
                                    :style="{ opacity: shownConfig.facebook ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.facebook ? 'selected' : 'unselected'"
                                >
                                    Facebook
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.linkedIn">
                            <template>
                                <q23-linkedin-svg
                                    color="#707070"
                                    class="svg"
                                    :style="{ opacity: shownConfig.linkedIn ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.linkedIn ? 'selected' : 'unselected'"
                                >
                                    LinkedIn
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.twitter">
                            <template>
                                <q24-x-logo-svg
                                    color="#707070"
                                    class="svg"
                                    :style="{ opacity: shownConfig.twitter ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.twitter ? 'selected' : 'unselected'"
                                >
                                    X (Formerly Twitter)
                                </span>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.youtube">
                            <template>
                                <t23-youtube-svg
                                    color="#707070"
                                    class="svg"
                                    :style="{ opacity: shownConfig.youtube ? 1 : 0.3 }"
                                />
                                <span
                                    class="button-label"
                                    :class="shownConfig.youtube ? 'selected' : 'unselected'"
                                >
                                    YouTube
                                </span>
                            </template>
                        </app-switch>
                    </div>
                </app-border-section>
                <app-border-section topText="Account Details">
                    <div class="input-container">
                        <app-switch v-model="shownConfig.contractEndDate">
                            <template>
                                <div
                                    class="button-label-no-svg"
                                    :class="shownConfig.contractEndDate ? 'selected' : 'unselected'"
                                >
                                    Contract End Date
                                </div>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.accountStartDate">
                            <template>
                                <div
                                    class="button-label-no-svg"
                                    :class="
                                        shownConfig.accountStartDate ? 'selected' : 'unselected'
                                    "
                                >
                                    Account Start Date
                                </div>
                            </template>
                        </app-switch>
                    </div>
                    <div class="input-container">
                        <app-switch v-model="shownConfig.contractStartDate">
                            <template>
                                <div
                                    class="button-label-no-svg"
                                    :class="
                                        shownConfig.contractStartDate ? 'selected' : 'unselected'
                                    "
                                >
                                    Contract Start Date
                                </div>
                            </template>
                        </app-switch>
                    </div>
                </app-border-section>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="transparent-btn" @click="closeWidget"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="saveHiddenFields"> Save </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AgencyUsersSearch = () => import('@/components/client/agency-users-search.vue');
const AppButton = () => import('@/components/common/app-button.vue');
const AppDatePicker = () => import('@/components/common/app-date-picker');
const AppInput = () => import('@/components/common/app-input.vue');
const AppTextArea = () => import('@/components/common/app-textarea');
const AppSwitch = () => import('@/components/common/app-switch');
const CompanyLocations = () => import('@/components/company/company-locations.vue');
const CompanyTypesDropdown = () => import('@/components/company/company-types-dropdown');
const CustomFieldDesignElement = () =>
    import('@/components/custom-field/custom-field-design-element');
const ImageUpload = () => import('@/components/common/image-upload.vue');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const Multiselect = () => import('vue-multiselect');
const O6AddSvg = () => import('@/components/svg/grid/o6-add-svg');
const QuickAddScrubbingSvg = () => import('@/components/svg/quick-add/quick-add-scrubbing-svg.vue');
const S3CloseSvg = () => import('@/components/svg/grid/s3-close-svg');
const ServiceDropdown = () => import('@/components/service/service-dropdown');
const VerticalDropdown = () => import('@/components/vertical/vertical-dropdown');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const AppBorderSection = () => import('@/components/common/app-border-section');
const N24LocationOutlineSvg = () => import('@/components/svg/grid/n24-location-outline-svg');
const K5EmailOutlineSvg = () => import('@/components/svg/grid/k5-email-outline-svg');
const G5CallOutlineSvg = () => import('@/components/svg/grid/g5-call-outline-svg');
const F18MobileOutlineSvg = () => import('@/components/svg/grid/f18-mobile-outline-svg');
const J24TeamsLogoOutlineSvg = () => import('@/components/svg/grid/j24-teams-logo-outline-svg');
const G24HomeOutline = () => import('@/components/svg/grid/g24-home-outline-svg');
const A26HeadsetSvg = () => import('@/components/svg/grid/a26-headset-svg');
const B26CalculatorCoinSvg = () => import('@/components/svg/grid/b26-calculator-coin-svg');
const C26FaxMachineSvg = () => import('@/components/svg/grid/c26-fax-machine-svg');
const P23FacebookSvg = () => import('@/components/svg/grid/p23-facebook-svg');
const Q23LinkedinSvg = () => import('@/components/svg/grid/q23-linkedin-svg');
const Q24XLogoSvg = () => import('@/components/svg/grid/q24-x-logo-svg');
const T23YoutubeSvg = () => import('@/components/svg/grid/t23-youtube-svg');
const P6WebsiteSvg = () => import('@/components/svg/grid/p6-website-svg');

import { CustomFieldsServiceMixin } from '@/mixins/custom-fields-service-mixin';
import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'company-field-hider-widget',

    components: {
        'agency-users-search': AgencyUsersSearch,
        'app-button': AppButton,
        'app-date-picker': AppDatePicker,
        'app-input': AppInput,
        'app-text-area': AppTextArea,
        'app-switch': AppSwitch,
        'company-locations': CompanyLocations,
        'company-types-dropdown': CompanyTypesDropdown,
        'custom-field-design-element': CustomFieldDesignElement,
        'image-upload': ImageUpload,
        'loading-screen-svg': LoadingScreenSvg,
        multiselect: Multiselect,
        'o6-add-svg': O6AddSvg,
        'quick-add-company-svg': QuickAddScrubbingSvg,
        's3-close-svg': S3CloseSvg,
        'service-dropdown': ServiceDropdown,
        'vertical-dropdown': VerticalDropdown,
        'widget-close-svg': WidgetCloseSvg,
        'app-border-section': AppBorderSection,
        'n24-location-outline': N24LocationOutlineSvg,
        'k5-email-outline-svg': K5EmailOutlineSvg,
        'g5-call-outline-svg': G5CallOutlineSvg,
        'f18-mobile-outline-svg': F18MobileOutlineSvg,
        'j24-teams-logo-outline-svg': J24TeamsLogoOutlineSvg,
        'g24-home-outline-svg': G24HomeOutline,
        'a26-headset-svg': A26HeadsetSvg,
        'b26-calculator-coin-svg': B26CalculatorCoinSvg,
        'c26-fax-machine-svg': C26FaxMachineSvg,
        'p23-facebook-svg': P23FacebookSvg,
        'q23-linkedin-svg': Q23LinkedinSvg,
        'q24-x-logo-svg': Q24XLogoSvg,
        't23-youtube-svg': T23YoutubeSvg,
        'p6-website-svg': P6WebsiteSvg,
    },

    mixins: [CustomFieldsServiceMixin],

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            shownConfig: {
                website: false,
                email: false,
                assignedUsers: false,
                billingAddress: false,
                phone: false,
                supportPhone: false,
                salesPhone: false,
                accountingPhone: false,
                fax: false,
                employees: false,
                numberOfDevices: false,
                vertical: false,
                description: false,
                services: false,
                facebook: false,
                linkedIn: false,
                twitter: false,
                youtube: false,
                contractEndDate: false,
                accountStartDate: false,
                contractStartDate: false,
            },

            defaultConfig: {
                website: true,
                email: true,
                assignedUsers: true,
                billingAddress: true,
                phone: true,
                supportPhone: true,
                salesPhone: true,
                accountingPhone: true,
                fax: true,
                employees: true,
                numberOfDevices: true,
                vertical: true,
                description: true,
                services: true,
                facebook: true,
                linkedIn: true,
                twitter: true,
                youtube: true,
                contractEndDate: true,
                accountStartDate: true,
                contractStartDate: true,
            },
        };
    },

    created() {
        this.getHiddenConfig();
    },

    methods: {
        getHiddenConfig() {
            this.$api
                .get('/ms/configs/v1/users?where=[{"Type": {"$eq": "company-shown-fields"}}]')
                .then((response) => {
                    if (response.data.data.length > 0) {
                        var res = JSON.parse(response.data.data[0].Config);
                        if (res) {
                            this.shownConfig = res;
                        } else {
                            this.shownConfig = this.defaultConfig;
                        }
                    } else {
                        this.shownConfig = this.defaultConfig;
                    }
                });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        saveHiddenFields() {
            var payload = {
                Type: 'company-shown-fields',
                Config: JSON.stringify(this.shownConfig),
            };

            this.$api
                .post('/ms/configs/v1/users', payload)
                .then(() => {
                    EventBus.$emit('user-config-company:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred saving your settings', { error });
                });
        },
    },
};
</script>

<style>
.company-field-hider-widget .input-container {
    position: relative;
}

.company-field-hider-widget .button-label {
    font-size: 16px;
}

.company-field-hider-widget .button-label-no-svg {
    font-size: 16px;
}

.company-field-hider-widget .svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
}

.company-field-hider-widget .p6-website-svg path {
    fill: #382153;
}

.company-field-hider-widget .p23-facebook-svg .a {
    fill: #707070;
}

.company-field-hider-widget .bordered-container {
    margin-top: -21px;
    padding-bottom: 31px;
}

.company-field-hider-widget .app-border-section {
    margin-bottom: 32px;
}

.company-field-hider-widget .app-border-section .title-wrapper .top-text {
    font-weight: bold;
}

.company-field-hider-widget .app-switch {
    padding-bottom: 30px;
}

.company-field-hider-widget .app-switch .app-switch-label {
    display: flex;
    align-items: center;
}

.company-field-hider-widget .action-container {
    display: flex;
}

.company-field-hider-widget .action-container .btn {
    margin-left: 15px;
}

.company-field-hider-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877d88;
}

.company-field-hider-widget .cancel-container .btn.transparent-btn:hover {
    background: #e1e0e5;
}

.company-field-hider-widget .action-container .btn.transparent-btn {
    background: transparent;
    color: #18aeff;
}

.company-field-hider-widget .action-container .btn.transparent-btn:hover {
    background: #dbedfa;
}

.company-field-hider-widget .bordered-container .add svg {
    margin-left: 16px;
}

.company-field-hider-widget .bordered-container .add svg path {
    fill: #ffffff;
}

.company-field-hider-widget .selected {
    font-weight: bold;
    color: #382153;
    stroke: #382153;
}

.company-field-hider-widget .unselected {
    font-weight: bold;
    color: #9b90a9;
}
</style>
